<template>
    <CRow v-if="link.type === false">
        <CCol col="12" md="8" class="mx-auto">
            <CRow class="content-center">
                <CCol col="12" md="3">
                    <CCard
                        @click="link.type = LinkType.EXCLUSIVE"
                        class="cursor-pointer text-center"
                    >
                        <CCardBody>
                            <img
                                style="width:100px"
                                src="https://img.icons8.com/color/100/000000/link--v2.gif"
                            />
                            <span
                                class="text-center d-block font-lg font-weight-bold mt-2"
                            >لینک اختصاصی</span>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol col="12" md="3">
                    <CCard
                        @click="link.type = LinkType.DEVELOPER"
                        class="cursor-pointer text-center"
                    >
                        <CCardBody>
                            <img
                                style="width:100px"
                                src="https://img.icons8.com/color/48/000000/developer--v2.gif"
                            />
                            <span
                                class="text-center d-block font-lg font-weight-bold mt-2"
                            >لینک توسعه‌دهنده</span>
                        </CCardBody>
                    </CCard>
                </CCol>
                <!-- <CCol col="12" md="3" v-if="!$policy('link').create_any_or_group">
                <CCard @click="link.type = LinkType.GENERAL" class="cursor-pointer text-center">
                    <CCardBody>
                        <img style="width:100px" src="https://img.icons8.com/officel/16/000000/globe--v2.gif"/>
                        <span class="text-center d-block font-lg font-weight-bold mt-2">لینک عمومی</span>
                    </CCardBody>
                </CCard>
                </CCol> -->
            </CRow>
        </CCol>
    </CRow>
    <CRow v-else>
        <CCol col="12" sm="9" class="mx-auto">
            <BackBtn @click="link.type = false" />
        </CCol>
        <CCol col="12" sm="9" class="mx-auto" v-if="link.type !== LinkType.GENERAL">
            <CAlert v-if="link.type === LinkType.DEVELOPER" class="alert-warning" role="alert">
                <p>پس از ایجاد لینک توسعه‌دهنده آدرس فروشگاه مورد نظر را می‌توانید با هر یک از روش‌های زیر به انتهای لینک توسعه ‌دهنده اضافه کنید.</p>
                <ul style="margin-right: -20px;">
                    <li>آدرس صفحه‌ی فروشگاه را با <a href='https://base64encode.org' style="text-decoration: underline;" target='_blank'>base64encode</a> رمزگذاری کرده و به انتهای لینک توسعه دهنده اضافه کنید.</li>
                    <li>ادرس صفحه فروشگاه را بدون رمزگذاری و با استفاده از پارامتر goto به انتهای آدرس بچسبانید.</li>
                </ul>
            </CAlert>
            <CCard>
                <CRow>
                    <CCol col="12" sm="6" class="p-0 m-0">
                        <CCardBody>
                            <Form :submit="submit" :link="link" ref="linkForm" />
                        </CCardBody>
                    </CCol>
                    <CCol col="12" sm="6" class="p-md-0 m-0">
                        <CCardBody>
                            <h5>عنوان چیست؟</h5>
                            <p>عنوان یک نام دلخواه است که شما برای لینک افیلیت خود در نظر می‌گیرید.</p>

                            <h5 v-if="link.type === LinkType.EXCLUSIVE">آدرس مقصد چیست؟</h5>
                            <p v-if="link.type === LinkType.EXCLUSIVE">آدرس مقصد صفحه‌ای از فروشگاه است که می‌خواهید کاربر بعد از کلیک روی لینک افیلیت به آن منتقل شود.</p>
                        </CCardBody>
                    </CCol>
                </CRow>
            </CCard>
        </CCol>
        <CCol col="12" sm="9" class="mx-auto" v-else>
            <CCard>
                <CCardBody>
                    <h5>{{ $t('link.how_to_use_public_link') }}</h5>
                    <p v-html="$t('link.use_public_link_description')"></p>

                    <div
                        dir="ltr"
                        class="d-block text-left py-3 bg-gray-900 text-white pfe-2"
                        style="border-radius:5px;"
                    >
                        <CLink
                            class="mfs-3 mfe-1"
                            v-clipboard:copy="publicLink"
                            v-clipboard:success="onCopyPublicLink"
                        >
                            <FaIcon icon="copy" class="text-affili-coral font-lg" />
                        </CLink>
                        <span>{{ publicLink }}</span>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import { Form } from './partials'
import { mapActions } from 'vuex'
import { StoreStatus, StoreUserRelationStatus, LinkType } from '@/constants'

/**
 * @deprecated
 */
export default {
    name: 'CreateLink',

    components: {
        Form
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchStores({
                no_paginate: true,
                status: StoreStatus.ACTIVE,
                store_users: {
                    status: StoreUserRelationStatus.ACTIVE,
                    user: {
                        id: vm.$currentUser().id
                    }
                }
            })
            vm.users()
        })
    },

    data() {
        return {
            LinkType,
            link: {
                title: '',
                href: '',
                store_id: '',
                type: false
            }
        }
    },

    computed: {
        publicLink() {
            return 'https://affili.ir/click/public-link/' + this.$currentUser().account_id + '/'
        }
    },

    methods: {
        ...mapActions({
            fetchStores: 'store/fetch',
            create: 'link/create',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            fetchUsers: 'user/fetch',
            setCToast: 'toastComponent/setCToast'
        }),
        users() {
            if (!this.$policy('link').create_any_or_group) {
                return
            }

            this.fetchUsers({
                no_paginate: true,
                role: {
                    accesses: ['link.manage_own']
                }
            })
        },
        submit() {
            const linkForm = this.$refs.linkForm
            this.setShowLoading()
            this.resetMsg()

            this.create(this.link).then(() => {
                this.$router.push({ name: 'links' })
            }).catch(result => {
                if (result.data) {
                    linkForm.$refs.form.setErrors(result.data)
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + result.tag),
                    type: 'danger'
                })
            })
        },
        onCopyPublicLink() {
            this.setCToast({
                msg: this.$t('link.public_link_copied'),
                class: 'text-white font-weight-bold bg-success'
            })
        },
    }
}
</script>